<template>
  <div :class="$style.logoNameContainer">YOGEN</div>
</template>

<script setup lang="ts"></script>
<style module>
  .logoNameContainer {
    display: flex;
    width: fit-content;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    font-size: 3rem;
    font-family: 'FatMolly';
    padding: 0 var(--space-8);
  }
</style>
